import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../../../../rootReducer';
import { basicApiAsyncThunkCreator } from '../../../../../services/apiAsyncThunkCreator';
import { CORE_SERVICES, HttpMethods } from '../../../../../services/api';
import { ICreditPool } from './interfaces';

export const fetchCreditPoolList: AsyncThunk<ICreditPool[], string, ThunkAPI> = createAsyncThunk(
  'creditPoolDistribution/fetchCreditPoolList',
  async (accountId: string, thunk) => {
    try {
      return await basicApiAsyncThunkCreator<ICreditPool[], undefined>({
        endpoint: `credit-pool/company/${accountId}`,
        microservice: CORE_SERVICES.CREDITS_SERVICE,
        authenticated: true,
        method: HttpMethods.Get,
        contentType: 'application/json'
      })(undefined, thunk);
    } catch (err) {
      return thunk.rejectWithValue(err);
    }
  }
);
